export default __webpack_public_path__ + "b04c17f1675813d2efae019152d5fa63.png";